import React from 'react';
import ConnectSocialMedia from '../../Components/ConnectSocialMedia';


const GoogleField = () => {
  return (
    <ConnectSocialMedia text='Login in with Google' icon='/icons/socialMedia/google.svg' />
  )
}

export default GoogleField;